interface SectionHeadingProps {
  tag: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ tag, title, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={`mb-8 md:mb-12 ${isCenter ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}`}>
      <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium tracking-widest uppercase text-accent-700">
        <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
        {tag}
      </span>
      <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mt-3 leading-snug">
        {title}
      </h2>
      {desc && <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">{desc}</p>}
    </div>
  );
}